// The portal permissions a client contact holds per client company (client-pages-api
// Logic/Permission.go). The API answers 401 when a gated route is called without one.
export enum Permissions {
    ViewInvoices = 101,
    ViewProjects = 201,
    AddTask      = 301,
}
